import { SelectButton } from './SelectButton'
import { withSelectButton } from './withSelectButton'

const ConnectedSelectButton = withSelectButton(SelectButton)

export { ConnectedSelectButton as SelectButton }
